<template>
  <div class="container">
    <div class="row">
      <div class="common__title-result">
        Расчет гидроизоляции
      </div>
      <div class="accordion" v-for="(item, i) in slicedResult" :key="`result-${i}`">
        <div class="accordion__head">
          <div class="accordion__head-major">
            <div class="image">
              <img :src="getMaterial(item.id).src" :alt="getMaterial(item.id).name">
            </div>
            <div class="title">{{ getMaterial(item.id).name }}</div>
          </div>
          <div class="accordion__head-minor">
            <div class="item">Ширина<br> рулона</div>
            <div class="item">Толщина<br> рулона</div>
            <div class="item">Длина<br> рулона</div>
            <div class="item item__transform">Площадь<br> <span>гидро</span>изоляции</div>
            <div class="item">Участки</div>
          </div>
        </div>
        <div class="accordion__body"
             v-for="(block, i) in item.sizes"
             :key="`block-${i}`"
             :class="{'accordion__body-active':
               showAccordionNav === `material-${item.id}-size-${i}`}">
          <div class="accordion__body-head"
               :class="{'accordion__body-head--active':
               showAccordionNav === `material-${item.id}-size-${i}`}">
            <div class="item">{{ block.width }} м</div>
            <div class="item">{{ block.thickness }} мм</div>
            <div class="item">{{ block.length }} м</div>
            <div class="item"><b>{{ block.square }} м²</b></div>
            <label class="item item__btn"
                   :for="`material-${item.id}-size-${i}`">{{ block.indices.length }}
              {{ getWord(block.indices.length) }}
            </label>
            <label class="showMore"
                   :for="`material-${item.id}-size-${i}`"
                   :class="{'showMore__active':
                   showAccordionNav === `material-${item.id}-size-${i}`}">
              <img src="@/assets/img/showMore.svg" alt="↓">
              <input type="radio"
                     @click="closeBody"
                     v-model="showAccordionNav"
                     :value="`material-${item.id}-size-${i}`"
                     :id="`material-${item.id}-size-${i}`">
            </label>
          </div>
          <div class="accordion__body-nav"
               v-if="showAccordionNav === `material-${item.id}-size-${i}`">
            <ResultMaterialsComputationNav :indices="block.indices"/>
          </div>
        </div>
      </div>
      <div class="showAll" @click="isShowAll = !isShowAll"
           :class="{'showAll__active': isShowAll}"
           v-if="resultMaterials.length > 3">
        <div class="showAll__text" v-if="!isShowAll">
          Показать все материалы
        </div>
        <div class="showAll__text" v-else>Скрыть</div>
        <button class="showAll__btn">
          <img src="@/assets/img/showMore.svg" alt="↓">
        </button>
      </div>
    </div>
  </div>
</template>
<script>

import { mapState } from 'vuex';
import ResultMaterialsComputationNav from '@/components/Result/ResultMaterialsComputationNav.vue';

export default {
  props: {
    resultMaterials: Array,
  },
  data() {
    return {
      showAccordionNav: null,
      isShowAll: false,
    };
  },
  components: {
    ResultMaterialsComputationNav,
  },
  methods: {
    getMaterial(id) {
      return this.allMaterials[this.allMaterials.findIndex(p => p.id === id)];
    },
    getWord(count) {
      const cases = [2, 0, 1, 1, 1, 2];
      const words = ['участок', 'участка', 'участков'];
      return words[(count % 100 > 4
        && count % 100 < 20) ? 2
        : cases[(count % 10 < 5)
          ? count % 10 : 5]];
    },
    closeBody() {
      this.showAccordionNav = null;
    },
  },
  computed: {
    ...mapState({
      // resultMaterials: state => state.result.total.materials,
      allMaterials: state => state.materials,
    }),
    slicedResult() {
      if (this.isShowAll) {
        return this.resultMaterials;
      } return this.resultMaterials.slice(0, 3);
    },
  },
};
</script>
<style lang="sass" scoped>
  .accordion
    margin-bottom: rem(34)
    width: 100%
    &__head
      text-align: left
      &-major
        background: #FFFFFF
        border: rem(1) solid #ECECEC
        border-radius: rem(4)
        display: flex
        flex-direction: row
        align-items: center
        +media((padding: (320: rem(16) rem(24), 768: rem(17) rem(20))))
        .image
          line-height: 0
          +media((padding-right: (320: rem(26), 768: rem(40))))
          img
            max-width: rem(100)
        .title
          font-style: normal
          font-weight: bold
          line-height: rem(22)
          display: flex
          color: $black
          +media((font-size: (320: rem(15), 768: rem(18))))
      &-minor
        background: #F6F6F6
        border-radius: rem(4) rem(4) 0 0
        display: grid
        +media((padding: (320: rem(10) rem(24), 768: rem(17) rem(40))))
        +media((grid-template-columns: (320: 6fr 6fr 5fr 5fr 2fr, 576: 1fr 1fr 1fr 1fr 1fr,
        700: 7fr 7fr 7fr 18fr 5fr)))
        .item
          font-style: normal
          font-weight: 500
          color: #5C5C5C
          display: flex
          flex-direction: row
          align-items: center
          +media((font-size: (320: rem(10), 360: rem(12), 768: rem(14))))
          +media((line-height: (320: rem(14), 360: rem(18), 768: rem(20))))
          &:last-of-type
            +media((display: (320: none, 576: flex)))
          &__transform
            display: inline-block
            span
              +media((display: (320: none, 768: inline-block)))
    &__body
      text-align: left
      transition: .5s
      &-active
        box-shadow: 0 rem(4) rem(14) rgba(0, 0, 0, 0.16)
      &-head
        display: grid
        background: #F6F6F6
        border-radius: rem(4)
        position: relative
        transition: .5s
        border-bottom: rem(1) solid #ECECEC
        +media((border: (320: 0, 768: rem(1) solid #ECECEC)))
        +media((padding: (320: rem(8) rem(24), 768: 0 rem(40))))
        +media((grid-template-columns: (320: 6fr 6fr 5fr 5fr 2fr, 576: 1fr 1fr 1fr 1fr 1fr,
        700: 7fr 7fr 7fr 18fr 5fr)))
        &--active
          background: #fff
          border-color: #ffffff
          border-radius: rem(4) rem(4) 0 0
        .item
          font-style: normal
          font-weight: 500
          display: flex
          flex-direction: row
          align-items: center
          color: $black
          +media((padding: (320: rem(8) 0, 768: rem(17) 0)))
          +media((font-size: (320: rem(12), 768: rem(16))))
          +media((line-height: (320: rem(18), 768: rem(24))))
          &__btn
            color: $red
            cursor: pointer
            +media((font-size: (320: rem(12), 768: rem(14))))
            +media((line-height: (320: rem(18), 768: rem(20))))
            +media((display: (320: none, 576: flex)))
        .showMore
          border: none
          background: none
          box-shadow: none
          height: 100%
          right: 0
          cursor: pointer
          outline: none
          display: flex
          flex-direction: row
          align-items: center
          +media((position: (320: relative, 576: absolute)))
          +media((padding-right: (320: 0, 576: rem(24))))
          justify-content: flex-end
          img
            transition: .5s
          &__active
            img
              transform: rotate(180deg)
        input[type="radio"]
          position: absolute
          left: 0
          top: 0
          height: 0
          width: 0
          display: none
          opacity: 0
          pointer-events: none
  .showAll
    background: #F6F6F6
    border: rem(1) solid #ECECEC
    box-sizing: border-box
    border-radius: rem(4)
    display: flex
    flex-direction: row
    align-items: center
    justify-content: space-between
    cursor: pointer
    margin: auto
    +media((width: (320: calc(100% - 48px), 992: 100%)))
    +media((padding: (320: rem(16) rem(20) rem(16) rem(26), 768: rem(25) rem(43) rem(25) rem(40))))
    &__text
      font-style: normal
      font-weight: 600
      font-size: rem(14)
      line-height: rem(17)
      color: $red
    &__btn
      border: none
      background: none
      box-shadow: none
      height: 100%
      cursor: pointer
      outline: none
      display: flex
      flex-direction: row
      align-items: center
      img
        transition: .5s
    &__active
      .showAll
        &__btn
          img
            transform: rotate(180deg)
</style>
